import React from "react"
import { default as Layout } from "../templates/LayoutAuth"

import SegmentRegister from "../large/SegmentRegister"

const Register = props => (
  <Layout>
    <SegmentRegister />
  </Layout>
)

export default Register



// WEBPACK FOOTER //
// ./src/pages/Register.js